// extracted by mini-css-extract-plugin
module.exports = {"faq__wrapper":"FAQList_faq__wrapper__OVj2c","faq__list":"FAQList_faq__list__5htNy"};